import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const SALES_API_PATH = '/api/sales';
const STRIPE_API_PATH = '/api/stripe';

const createPaymentIntent = async (amount) => {
  const response = await axios.post(`${API_BASE_URL}${STRIPE_API_PATH}/create-payment-intent`, { amount });
  return response.data;
};

const createSale = async (saleData) => {
  const response = await axios.post(`${API_BASE_URL}${SALES_API_PATH}`, saleData);
  return response.data.data;
};

// --- THE FIX IS HERE: Send customerId with the preview request ---
const previewSale = async (cartItems, storeId, customerId, selectedPromotionIds = []) => {
  const response = await axios.post(`${API_BASE_URL}${SALES_API_PATH}/preview`, { items: cartItems, storeId, customerId, selectedPromotionIds });
  return response.data.data;
};

const salesService = {
  createSale,
  previewSale,
  createPaymentIntent,
};

export default salesService;
